"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = UserDropdown;

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _utils = require("@dom/utils");

var _Toggler = _interopRequireDefault(require("../Toggler"));

var _LoginOrLogout = _interopRequireDefault(require("./LoginOrLogout"));

var _DropdownElements = _interopRequireDefault(require("./DropdownElements"));

function UserDropdown(props) {
  var logout = props.logout,
      openLoginModal = props.openLoginModal,
      openSignUpModal = props.openSignUpModal,
      userInfo = props.userInfo,
      isUserLoggedIn = props.isUserLoggedIn,
      location = props.location;
  var urlOfProfile = '',
      urlOfPurchaseList = '';

  if (isUserLoggedIn) {
    var name = userInfo.name,
        userId = userInfo.userId;
    urlOfProfile = _utils.makeUrl.goToProfile(name, userId);
    urlOfPurchaseList = "".concat(_utils.makeUrl.goToProfile(name, userId), "/purchase-list");
  }

  return _react["default"].createElement(_Toggler["default"], null, function (_ref) {
    var on = _ref.on,
        toggle = _ref.toggle;
    return _react["default"].createElement(_reactstrap.Dropdown, {
      isOpen: on,
      toggle: toggle,
      className: "user-btn-dp"
    }, _react["default"].createElement(_reactstrap.DropdownToggle, {
      caret: true,
      color: "none",
      className: "btn-nav-bar dp-toggle"
    }, _react["default"].createElement("div", {
      className: "notification-icon_container user-navbar"
    }, isUserLoggedIn ? _react["default"].createElement("img", {
      src: userInfo.image
    }) : _react["default"].createElement("img", {
      src: "https://s3.amazonaws.com/honeyguide/assets/icons/user.svg",
      alt: ""
    }))), _react["default"].createElement(_reactstrap.DropdownMenu, {
      className: "setting-dp",
      right: true
    }, _react["default"].createElement(_DropdownElements["default"], {
      link: urlOfProfile,
      title: "Profile",
      isElementVisible: isUserLoggedIn,
      location: location
    }), _react["default"].createElement(_DropdownElements["default"], {
      link: urlOfPurchaseList,
      title: "Purchase List",
      isElementVisible: isUserLoggedIn,
      location: location
    }), _react["default"].createElement(_DropdownElements["default"], {
      link: '/policies/terms-services',
      title: "Terms of Services",
      isElementVisible: true,
      location: location
    }), _react["default"].createElement(_DropdownElements["default"], {
      link: '/admin',
      title: "Admin Dashboard",
      isElementVisible: (0, _utils.isSuperUser)(),
      location: location
    }), _react["default"].createElement(_DropdownElements["default"], {
      link: '/admin/bookings',
      title: "Bookings Dashboard",
      isElementVisible: (0, _utils.isSuperUser)()
    }), _react["default"].createElement(_LoginOrLogout["default"], {
      isLoggedIn: isUserLoggedIn,
      logout: logout,
      openLoginModal: openLoginModal,
      openSignUpModal: openSignUpModal
    })));
  });
}